// AppRouter.js

import { useContext } from "react";
import { Context } from '../index'
import { publicRoutes } from "./routes";
import { Navigate, Route, Routes } from "react-router-dom";
import { HOME_ROUTE } from "../constants/constants";
import { observer } from "mobx-react-lite";
import Home from "../pages/Home/Home";
import Page404 from "../pages/ErrorPage/Page404";
import { Outlet } from "react-router-dom";
import { useState } from 'react';


import adminRoutes from "./AdminRouter";
import studentRoutes from "./StudentRouter";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner"; // Кастомный спиннер
// import teacherRoutes from "./TeacherRouter";

import TeacherCabinet from "../pages/TeacherCabinet";
import TeachersCabinetContent from '../pages/TeacherCabinet/views/Courses'
import TeachersCoursesSections from '../pages/TeacherCabinet/views/Sections'
import TeachersCoursesTopics from '../pages/TeacherCabinet/views/Topics'
import SingleTopic from '../pages/TeacherCabinet/views/Topic';
import AddSection from '../pages/TeacherCabinet/views/AddSection'
import EditSection from "../pages/TeacherCabinet/views/EditSection";
import AddStreamForm from '../pages/TeacherCabinet/components/forms/AddStream';
import AddTopic from '../pages/TeacherCabinet/views/AddTopic';
import EditTopic from '../pages/TeacherCabinet/views/EditTopic';

import Paragraphs from "../pages/TeacherCabinet/pages/paragraphs/Paragraphs";
import Themes from "../pages/TeacherCabinet/pages/themes/Themes";
import Streams from "../pages/TeacherCabinet/pages/streams/Streams";
import Homeworks from "../pages/TeacherCabinet/pages/homeworks/Homeworks";
import Tests from "../pages/TeacherCabinet/pages/tests/Tests";

import HomeworkEditor from "../pages/TeacherCabinet/pages/tests/HomeworkEditor";

import CuratorChat from "../pages/CuratorChat/CuratorChat";

const AuthRouteMiddleware = ({ children, role }) => {
    const { user } = useContext(Context);
    const [loading, setLoading] = useState(false);

    if (user.isAuth === undefined) {
        return <LoadingSpinner />; {/* Заменяем стандартную загрузку на кастомную */ }
    }

    if ((user.role && user.role === role) || (role === 'anonymous' && !user.isAuth)) {
        return children;
    }

    return <Navigate to={user.userHomePath} replace />
}
const AppRouter = observer(() => {


    return (
        <Routes>
            {/* Кабинет куратора */}
            <Route path="/curator" element={<AuthRouteMiddleware role="curator"><CuratorChat /></AuthRouteMiddleware>} />

            {/* Кабинет преподавателя */}
            <Route path="/teachers-cabinet" element={<AuthRouteMiddleware role="teacher"><TeacherCabinet /></AuthRouteMiddleware>} >
                <Route index element={<TeachersCabinetContent />} />
                <Route path='course/:id' element={<TeachersCoursesSections />} />
                <Route path='course/:id/add-section' element={<AddSection />} />
                <Route path='section/:id' element={<TeachersCoursesTopics />} />
                <Route path='section/:paragraph_id/add-theme' element={<AddTopic />} />
                <Route path='section/:paragraph_id/edit' element={<EditSection />} />
                <Route path='theme/:theme_id/edit' element={<EditTopic />} />
                <Route path='theme/:id' element={<SingleTopic />} />
                <Route path='theme/:id/stream' element={<AddStreamForm />} />

                <Route path='paragraphs' element={<Paragraphs />} />
                <Route path='themes' element={<Themes />} />
                <Route path='streams' element={<Streams />} />
                <Route path='homeworks' element={<Homeworks />} />
                <Route path='tests' element={<Tests />} />

                <Route path="/teachers-cabinet/homeworks/:homework_id/edit" element={<HomeworkEditor />} />
            </Route>

            {/* Админ-панель */}
            <Route path="/admin" element={<AuthRouteMiddleware role="admin"><Outlet /></AuthRouteMiddleware>}>
                {adminRoutes.map(
                    ({ Component, ...rest }) => (
                        <Route key={rest.path} {...rest} element={<Component />} />
                    )
                )}
            </Route>


            {/* Профиль студента */}
            {studentRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<AuthRouteMiddleware role="student"> <Component /></AuthRouteMiddleware>} />
            ))}

            {/* Страница входа */}
            <Route exact path={HOME_ROUTE} element={<AuthRouteMiddleware role="anonymous"><Home /></AuthRouteMiddleware>} />

            {/* <Route path="*" element={<Page404 />} /> */}

        </Routes>
    );
})
export default AppRouter;